import React from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "components/ui/button"

const NotFoundPage = () => {
  const navigate = useNavigate()
  return (
    <div className="text-center space-y-4">
      <h1 className="font-semibold mb-16 text-blue-700">
        404 - Page Not Found
      </h1>
      <div>
        <h3>Désolé la page recherchée n'existe pas 😒</h3>
        <p>Assurez vous d'être connecté et d'être sur un lien valide.</p>
      </div>
      <Button onClick={()=> navigate("/")} className="bg-blue-700">
        Retour à l'accueil
      </Button>
    </div>
  )
}

export default NotFoundPage
